import React from "react";
import { NavLink } from "react-router-dom";
import { _ } from "libs";

const SettingsSidebar = () => (
	<div className="sidebarMenu">
		<NavLink className="account" to="/settings/account">
			{_("settings.nav.account")}
		</NavLink>
		<NavLink className="profile" to="/settings/profile">
			{_("settings.nav.profile")}
		</NavLink>
		<NavLink className="billing" to="/settings/billing">
			{_("settings.nav.billing")}
		</NavLink>
		<NavLink className="memberships" to="/settings/memberships">
			{_("settings.nav.memberships")}
		</NavLink>
		<NavLink className="notifications" to="/settings/notifications">
			{_("settings.nav.notifications")}
		</NavLink>
		<NavLink className="privacy" to="/settings/privacy">
			{_("settings.nav.privacy")}
		</NavLink>
	</div>
);

export default SettingsSidebar;
